// import { createMuiTheme } from '@material-ui/core/styles'
import { createTheme } from '@material-ui/core/styles'

const muiTheme = createTheme({
    typography: {
        // Use the system font.
        fontFamily: 'Prompt, sans-serif',
        button: {
            textTransform: 'none',
        },
        body1: {
            fontSize: '16px',
        },
        body2: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '16px',
        },
    },
    palette: {
        primary: {
            main: '#db5f8e',
            dark: '#e8548c',
            // light: '#ff9873',
            // contrastText: '#F9F9F9',
        },
        secondary: {
            main: '#be3144',
        },
        text: {
            primary: '#21211F',
            secondary: '#333131',
        },
        background: {
            default: '#ffffff',
        },
        grey: {
            50: 'rgba(0, 0, 0, 0.25)',
        },
    },
    overrides: {
        MuiGrid: {
            root: {
                overflowWrap: 'break-word',
            },
        }
    }
})

const mainTheme = {
    ...muiTheme,
}

export default mainTheme
